import React from "react";
import {ReviewCTABox, ReviewCTASection, TickMark, TickMarkKick, TickMarkStem} from "./Styled";
import Card from "../../../WidgetCard";
import ReviewSort from "./Sort";
import PropTypes from "prop-types";
import {pageTrackingData} from "../../../../utils/utils";
import RequestACallBackCTA from "../../../CTA/RequestACallBackCTA";
import {COUNSELING_REVIEW_PAGE_PROP_MAP} from "../../../../containers/CounselingReviewPage/utils";
import CounselingRatingWidget from "../../CounselingReviewWidget/widgets/CounselingRatingWidget";
import WriteACounselorReview from "../../../CTA/WriteACounselorReview";
import {prepareDataForWriteACounselorReview} from "../../../CTA/WriteACounselorReview/utils";

const ReviewTopSection = (props) => {
    const {data} = props;
    let requestACallBackTrackingData = pageTrackingData(
        props.isMobile,
        COUNSELING_REVIEW_PAGE_PROP_MAP,
    ).requestACallBack;

    const writeAReviewData = prepareDataForWriteACounselorReview({
        isMobile: props.isMobile,
        pageConfig: COUNSELING_REVIEW_PAGE_PROP_MAP,
        field: "writeACounselorReview",
    });
    return (
        <Card
            widgetHeading={"Shiksha Counseling Service Reviews"}
            headingStyle={{
                mobile: {fontSize: "1.125rem", padding: "0"},
                laptop: {fontSize: "1.125rem", padding: "0"},
            }}
            cardStyle={{mobile: {padding: "0"}, laptop: {padding: "0"}}}
        >
            <CounselingRatingWidget data={data} makeVerticalRatingStyle={false} />

            <ReviewCTASection>
                <ReviewCTABox>
                    <TickMark>
                        <TickMarkStem />
                        <TickMarkKick />
                    </TickMark>
                    <p>
                        All reviews have been published after ensuring that the reviewers are{" "}
                        <strong>bona fide students</strong> of Shiksha counseling service.
                    </p>
                </ReviewCTABox>
                <ReviewCTABox>
                    <WriteACounselorReview
                        trackingData={writeAReviewData}
                        renderType={"White Button"}
                    />
                    <RequestACallBackCTA
                        trackingId={requestACallBackTrackingData.trackingId}
                        widget={requestACallBackTrackingData.widget}
                        eventCategory={requestACallBackTrackingData.eventCategory}
                        eventAction={requestACallBackTrackingData.eventAction}
                        autoTriggerBasedOnParams
                    />
                </ReviewCTABox>
            </ReviewCTASection>
            <ReviewSort doSort={props.doSort} sortType={props.sortType} />
        </Card>
    );
};

ReviewTopSection.propTypes = {
    data: PropTypes.object,
    doSort: PropTypes.func,
    sortType: PropTypes.string,
    userLoggedIn: PropTypes.bool,
    isMobile: PropTypes.bool,
};
export default ReviewTopSection;
